<!--  -->
<template>
  <div class="wrapper">
    <div class="wrapper-left" id="treeList" :class="{'zoom-in':showRightTree}">
      <h3 class="title">
        <span>Classification</span>
        <!-- <span v-if="!showRightTree" class="zoom-in-btn box-shadow" @click="zoomIn"><i class="icon zoom-in"></i> Zoom In</span>
        <span v-else class="zoom-out-btn box-shadow" @click="zoomOut"><i class="icon zoom-out"></i> Zoom Out</span> -->
      </h3>
      <!-- <div v-if="!showRightTree">
        <v-tree :nodeId="nodeId" @updateNodeId="updateNodeId" ></v-tree>
      </div> -->
      <!-- <div v-else>
        <right-tree :list="list" ></right-tree>
      </div> -->
      <v-tree :zoom="showRightTree" @updateNodeId="updateNodeId"></v-tree>
    </div>
    <div class="wrapper-right" v-show="!showRightTree">
      <v-tabs :nodeId="nodeId"></v-tabs>
    </div>
  </div>
</template>

<script>
import { getTreeList } from "@/api/index";
import VTree from "@/components/tree/index";
import VTabs from "./taxa/index";
// import RightTree from "@/components/tree/rightTreeOrigin";
export default {
  name: "gloss",
  components: {
    VTree,
    VTabs
  },
  data() {
    return {
      nodeId: "",
      showRightTree: false,
      list: [],
      zoomText:'Zoom In',
    };
  },
  //生命周期 - 创建完成（访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（访问DOM元素）
  mounted() {},
  methods: {
    getTreeNode(list) {
      //   console.log(list);
    },
    zoomIn() {
      this.showRightTree = !this.showRightTree;
    },
    zoomOut() {
        this.showRightTree = !this.showRightTree;
    },
    updateNodeId(id) {
      this.nodeId = id;
    },
  },
};
</script>
<style>

.wrapper-left {
  width: 400px;
  min-width: 360px;
  margin-right: 12px;
  padding: 0 20px;
  /* header-top 95 */
  min-height: calc(100vh - 170px);
  max-height: 1000px;
  overflow: auto;
  border: 2px solid #efefef;
}
.wrapper-left.zoom-in {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
}
 .title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 68px;
}
.title > span {
  font-style: normal;
  font-weight: 500;
  font-size: 24px;
  line-height: 56px;
  color: #484d63;
}
.title span.zoom-out-btn,
.title span.zoom-in-btn {
  height: 35px;
  padding: 0 12px;
  line-height: 35px;
  font-size: 16px;
  background: rgba(255, 255, 255, 0.6);
}
.zoom-out-btn i,
.zoom-in-btn i {
  display: inline-block;
  width: 15px;
  height: 100%;
  vertical-align: top;
  background: url("../../assets/images/zoom_in.png") no-repeat center;
  background-size: 15px;
  margin-right: 8px;
  cursor: pointer;
}
.zoom-out-btn i.zoom-out{
    background-image: url("../../assets/images/zoom_out.png");
}
.zoom-in-btn{
    width: 120px;
}
.zoom-out-btn{
    width: 150px;
}
.more {
  background: url("../../assets/images/more.png") no-repeat right center;
  background-size: 6px 9px;
  font-weight: 500;
  font-size: 16px;
  line-height: 37px;
  color: #72c2c9;
  padding: 0 15px;
}
.wrapper-right {
  width: calc(100% - 400px);
  min-width: 600px;
}
</style>